export default "/images/c2d276280c2544bfee9cb008a76a5edd.jpg";